var map = {
	"./en-CA.json": 6417,
	"./en-US.json": 6418,
	"./es.json": 6419,
	"./extractions.json": 6420,
	"./fr-CA.json": 6421,
	"./fr.json": 6422,
	"./nl-NL.json": 6423
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1500;


//////////////////
// WEBPACK FOOTER
// ./locales ^\.\/.*\.json$
// module id = 1500
// module chunks = 0